import { Headset } from "lucide-react";
import { NodeCategory, registerNode } from "../../lib/register-node";
import { ZendeskActionNodeEditor } from "./editor";
import { ZendeskActionNodePanel } from "./panel";

const newNodeDefaultConfig: any = {
  title: {},
  description: {},
};

const newNodeDefaultValue: any = {
  actionType: "create_ticket_on_zendesk",
  config: newNodeDefaultConfig,
};

export default registerNode<any["data"]>({
  type: "action:create_ticket_on_zendesk",
  name: "workflowsEditor.nodes.createZendeskTicket.title",
  description: "workflowsEditor.nodes.createZendeskTicket.description",
  Icon: Headset,
  category: NodeCategory.ACTION,
  color: "blue",
  editor: {
    component: ZendeskActionNodeEditor,
  },
  configPanel: {
    component: ZendeskActionNodePanel,
  },
  newNodeDefaultData: newNodeDefaultValue,
});

export { ZendeskActionNodeEditor } from "./editor";
export { ZendeskActionNodePanel } from "./panel";
